import { Head, Link } from '@inertiajs/react'
import Form from './form'
import type { CategoryType } from './types'

interface EditProps {
  category: CategoryType
  communities: {
    id: string
    name: string
  }[]
}

export default function Edit({ category, communities }: EditProps) {
  return (
    <>
      <Head title="Editing category" />

      <div className="mx-auto md:w-2/3 w-full px-8 pt-8">
        <h1 className="font-bold text-4xl">Editing category</h1>

        <Form
          category={category}
          communities={communities}
          action={`/system/categories/${category.id}`}
          method="patch"
          submitText="Update Category"
        />

        <Link
          href={`/system/categories/${category.id}`}
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Show this category
        </Link>
        <Link
          href="/system/categories"
          className="ml-2 rounded-lg py-3 px-5 bg-gray-100 inline-block font-medium"
        >
          Back to categories
        </Link>
      </div>
    </>
  )
}
